import React, {useState} from 'react';
import {Button, Col, Layout, Row} from "antd";
import {Content} from "antd/es/layout/layout";
import img1 from './imgs/NEW_Infographic without circles.webp'
import './style.scss'
import {SFW_TEXT} from "./text";
import img2 from './imgs/img.png'
import img3 from './imgs/Software footer.webp'

const Software = (props) => {
    const [hoverText, setHoverText] = useState(null);

    const circles = [
        {id: 'art-library', label: 'ART LIBRARY',
            text: (
                <p>
                    Explore the Vieunite Pro <span style={{fontWeight:"bold"}}>Art Library</span>, where art of every genre is displayed to inspire your imagination and bring life to your surroundings.
                </p>
            ),
        },
        {id: 'curated-collections', label: 'CURATED COLLECTIONS', text: ''},
        {id: 'image-video-upload', label: 'IMAGE & VIDEO UPLOAD',text: ''},
        {id: 'playlists', label: 'PLAYLISTS',text: ''},
        {id: 'manage-devices', label: 'MANAGE DEVICES',text: ''},
        {id: 'art-market', label: 'ART MARKET',text: ''},
    ];
    return (
        <Layout>
            <Content>
                <Row justify={"center"}
                     style={{
                         margin: '8rem 0 0 0',
                         display: "flex",
                         flexDirection: "column",
                         alignItems: "center",
                         justifyContent: "center"
                     }}
                >
                    <p className={'sfw-head'}>
                        Take control
                    </p>
                    <p className={'sfw-subhead'}>
                        of what you display with our intuitive software
                    </p>
                </Row>
                <Row justify={"center"}>
                    <Col lg={20} className={'sfw-circle-col'}>
                        <img src={img1} className={'backgroundImage'}/>
                        {circles.map((circle) => (
                            <div
                                key={circle.id}
                                className={`circle ${circle.id}`}
                                onMouseEnter={() => setHoverText(circle.text)}
                                onMouseLeave={() => setHoverText(null)}
                            >{circle.label}</div>
                        ))}
                        <div className="center-text">{hoverText}</div>
                    </Col>
                </Row>
                <Row justify={"center"}>
                    <Button className={'sft-btn-portal'}
                            onClick={() => {
                                window.location.href='/business/prologin'
                            }}
                    >
                        Explore the Vieunite Portal
                    </Button>
                </Row>

                <Row justify={"center"} style={{margin: '4rem 0 0 0'}}>
                    <Col lg={10} className={'sfw-img-col'}>
                        <p className={'sfw-small-title'}> Discover Art</p>
                        <img src={img2} style={{width: '35vw'}}/>
                        <p className={'sfw-small-txt'}>{SFW_TEXT['Discover Art']}</p>
                    </Col>
                    <Col lg={10} className={'sfw-img-col'}>
                        <p className={'sfw-small-title'}>My Library</p>
                        <img src={img2} style={{width: '35vw'}}/>
                        <p className={'sfw-small-txt'}>{SFW_TEXT['My Library']}</p>
                    </Col>
                </Row>
                <Row justify={"center"}>
                    <Col lg={10} className={'sfw-img-col'}>
                        <p className={'sfw-small-title'}>Textura Pro Dashboard</p>
                        <img src={img2} style={{width: '35vw'}}/>
                        <p className={'sfw-small-txt'}>{SFW_TEXT.Dashboard}</p>
                    </Col>
                    <Col lg={10} className={'sfw-img-col'}>
                        <p className={'sfw-small-title'}>Account Settings</p>
                        <img src={img2} style={{width: '35vw'}}/>
                        <p className={'sfw-small-txt'}>{SFW_TEXT["Account"]}</p>
                    </Col>
                </Row>
                <Row justify={"center"}>
                    <Col lg={20}>
                        <div className="image-container">
                            <img src={img3} alt="Background" className="background-image"/>
                            <div className="sfw-content">
                                <p className={'content-head'}>Connecting Your Hardware</p>
                                <p className={'content-txt'}>An easy-to-use app has been designed specifically for
                                    connecting hardware devices. Its functions include pairing the portal with hardware
                                    devices, changing the names of the hardware, removing hardware, and providing quick
                                    control to switch the hardware on/off.</p>
                                <Button className={'content-btn'}
                                onClick={_=>window.location.href='/app.html'}>
                                    Download our App
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Content>
        </Layout>
    )
}

export default Software;
